export default (value: string | null) => {
  if (value === null) return true

  if (Number.parseInt(value) < 123456) {
    return "Invalid account number"
  }

  if (value.length < 6 || value.length > 8) {
    return "Account number must have 6-8 digits"
  }

  return true
}
